
<template>
    <div class="features_box rounded-10">
        <div class="features_box-icon color-graph-purple ">
            <b-icon :icon="icon" :class="iconColorClass" />
        </div>
        <div :class="['features_box-text-wrapper', backgroundColorClass , 'color-white']">
            <div class="features_box-title">{{ title }}</div>
            <div class="features_box-text">{{text}}</div>
        </div>
    </div>
</template>

<script>

    export default {
        name: 'StatNumber',
        props: {
            backgroundColorClass: { type: String },
            iconColorClass: { type: String },
            icon: { type: String },
            title: { type: String },
            text: { type: String },
        },
        data: function () {
            return {
                
            }

        },
    }
</script>
